(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

    const sectionId = ("YurchakDifferent-" + __shopifySectionId + "");

    const initializeWhyDifferent = () => {
      const section = document.getElementById(sectionId);

      if (!section || section.dataset.ywdInitialized === 'true') {
        return;
      }

      section.dataset.ywdInitialized = 'true';

      const track = section.querySelector('[data-ywd-track]');
      const cards = Array.from(section.querySelectorAll('[data-ywd-card]'));
      const indicators = Array.from(section.querySelectorAll('[data-ywd-indicator]'));

      if (!track || !cards.length || !indicators.length) {
        return;
      }

      const setActiveIndicator = (activeIndex) => {
        indicators.forEach((indicator, index) => {
          const active = index === activeIndex;
          indicator.classList.toggle('is-active', active);
          indicator.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const getClosestCardIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const trackStart = trackRect.left;

        let nearestIndex = 0;
        let nearestDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs(cardRect.left - trackStart);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      const scrollToCard = (index) => {
        const card = cards[index];
        if (!card) return;

        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });

        setActiveIndicator(index);
      };

      let scrollFrame = null;

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);

          scrollFrame = requestAnimationFrame(() => {
            setActiveIndicator(getClosestCardIndex());
          });
        },
        { passive: true }
      );

      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          scrollToCard(index);
        });
      });

      setActiveIndicator(0);
    };

    initializeWhyDifferent();

    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection = event.target.querySelector?.(`#${sectionId}`);
      if (!loadedSection) return;

      loadedSection.dataset.ywdInitialized = 'false';
      initializeWhyDifferent();
    });
  })();
